import axios from "axios";
import AxiosClient from "../../../services/axios.services";

class PlanAccionServices {
  getPlanAcciones = params =>
    AxiosClient.get("/api/app/evaluacion_tipo_plan_accion/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });  
  getPlanAccion = id =>
    AxiosClient.get(`/api/app/evaluacion_tipo_plan_accion/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  savePlanAccion = data =>
    AxiosClient.post("/api/app/evaluacion_tipo_plan_accion/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editPlanAccion = (id, data) =>
    AxiosClient.put(
      `/api/app/evaluacion_tipo_plan_accion/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deletePlanAccion = id =>
    AxiosClient.delete(`/api/app/evaluacion_tipo_plan_accion/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new PlanAccionServices();